import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavigation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M8.886 2.557a1.172 1.172 0 0 1 2.228 0l5.055 13.996c.406 1.125-.79 2.143-1.756 1.494l-3.771-2.53a1.144 1.144 0 0 0-1.284 0l-3.771 2.53c-.966.649-2.162-.37-1.756-1.494L8.886 2.557Z"
	})]
});
const ForwardRef = forwardRef(SvgNavigation);
export { ForwardRef as ReactComponent };
